import { render, staticRenderFns } from "./taskItemScannedList.vue?vue&type=template&id=500bd644&"
import script from "./taskItemScannedList.vue?vue&type=script&lang=js&"
export * from "./taskItemScannedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports